var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownSLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 8.78126L11.2998 5.48145L12.2426 6.42425L7.99993 10.6669L3.75732 6.42425L4.70013 5.48145L7.99993 8.78126Z",
    fill: "#FFE700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSLine);
export default __webpack_public_path__ + "static/media/arrow-down-s-line.d31be4cda31829052fdaa7633009a1ed.svg";
export { ForwardRef as ReactComponent };